/* globals ga:false */
import VersionChecker from './cob.versionchecker.js';

var Modules = function(core, routing, security, loading){
   var
    // the cob.loading key
      _loadingKey = loading.getLoadingKey(),

    // Keep the modules definitions. Usefull to get the module uri
       _moduleDefinitions = {},

    //The module instance stack
       _moduleStack = [],

    //The currently active module
       _activeModule,

    // functions that we want to export
       exports = {};


    // Register a module
    var _registerModule = function(module) {
        //window.console.log('cob.Modules: Registering module: ' + module.name);

        // We add the module definition to our dictionary.
        _moduleDefinitions[module.name] = module;

        // If the module has associated uri values register them
        if (module.uri) {
            module.uri.forEach(function (uri) {
                routing.register(uri, module.name);
            });
        }
    };

    // Register a given list of app modules
    exports.registerModules = function(moduleDefs) {
        var i = 0;

        window.console.log("cob.Modules: Registering Modules...");

        for (; i < moduleDefs.length; i++) {
            _registerModule(moduleDefs[i]);
        }
    };

    //creates instances for all registered Modules. Only used with _pseudo-modules_.
    exports.initAllModules = function(moduleDefs) {
        var instances = {};
        moduleDefs.forEach(function(def) {
            instances[def.name] = _createModule(def);
        });
        return instances;
    };

    var _createModule = function(module, params) {
        // we call the module's constructor
        var instance = new module.constructor(core, module.baseUri);

        // we add to the name of the module to the new instance
        instance.name = module.name;

        // we call the module's init method
        if (instance.init) instance.init.apply(instance, params ? params : []);

        return instance;
    };

    var _setActiveModule = function(moduleName, instance, stateId, hash) {
        _activeModule = {
            id: stateId,
            name: moduleName,
            instance: instance,
            hash: hash
        };

    };

    //Returns an existing module instance for the given `stateId`. Returns `undefined`
    //if no instance exists on the stack for that `stateId`.
    //
    //Calls destroy on all the instances after the one we are navigating to,
    //removing them from the stack
    var _getModuleForStateAndTrimStack = function(stateId) {
        var module,
            trimFrom;

        _moduleStack.forEach(function(entry, idx) {
            if (entry.id === stateId) {
                module = entry;
                trimFrom = idx + 1; //we'll trim all in front of this module
            }
        });

        if(module){
            _moduleStack.splice(trimFrom, _moduleStack.length - trimFrom).forEach(function(entry){
               entry.instance.destroy();
            });
        }

        return module;
    };

    //Shows a module, starting one if needed or re-using an existing one
    //
    //arguments:
    //
    //* `moduleName` : specifiy the module name
    //* `params`     : use this to provide information to the module
    //                 that will allow it to do something after it has started
    //* `stateId`    : the id of the state to restore, or to use for the new instance
    //* `unsecured`  : if truthy we'll skip the permissions check. Useful for pseudo-modules
    //* `hash`       : may contain the location.hash that triggered the navigation
    exports.goToModule = function(moduleName, params, stateId, unsecured, hash) {
        var module;

        // we'll only start if we have permissions for it
        if (!unsecured && !security.hasPermission("module:view:" + moduleName)) {
            window.console.log("user doesn't have the permission 'module:view:" + moduleName + "'");
            return false;
        }

        loading.showLoading(_loadingKey, "_goToModule(" + moduleName + "," + params + ")");

        const serverVersion = core.getAppInfoModel().version;
        const runningVersion = core.getSettings().app_version
        VersionChecker.reloadAppIfNeeded(runningVersion, serverVersion);

        if (_activeModule) _activeModule.instance.pause();

       /* eslint-disable no-undef */
       if(!unsecured){
          if(typeof cob !== 'undefined' && cob.custom && cob.custom.naked && cob.custom.naked(moduleName, params)){
             $('body').addClass('naked')
          } else {
             $('body').removeClass('naked')
          }
       }
       /* eslint-enable no-undef */

        module = _getModuleForStateAndTrimStack(stateId);

        //todo jone retirar este HACK assim que tivermos analytics a s�rio
        //we don't want unsecured modules, they are not "real" "pages"
        if(typeof ga !== 'undefined' && !unsecured) ga('send', 'pageview', moduleName);

        if (module === undefined) {
            if(_activeModule && _activeModule.name === moduleName
               && _activeModule.instance.acceptsRoute && _activeModule.instance.acceptsRoute(params)){
               _setActiveModule(moduleName, _activeModule.instance, stateId, hash);
               _activeModule.instance.resume(params);

            } else {
               _setActiveModule(moduleName, _createModule(_moduleDefinitions[moduleName], params), stateId, hash);
               _moduleStack.push(_activeModule);
            }

        } else {
            _setActiveModule(moduleName, module.instance, stateId, hash);
            _activeModule.instance.resume(params);
        }

        if(!unsecured){
           // we'll publish un updated module stack
           core.publish("modules:stack-updated", {stack: _moduleStack});
        }

        loading.hideLoading(_loadingKey, "_goToModule(" + moduleName + "," + params + ")");

        return true;
    };

    exports.pauseActiveModule = function() {
       if (_activeModule){
          _activeModule.instance.pause();
          _activeModule = undefined;
       }
    };

    // The size of the current module stack application
    exports.moduleStackLength = function() {
        return _moduleStack.length;
    };

    //Resets the module stack calling `destroy()` on all module instances
    exports.resetModules = function () {
        _moduleStack.forEach(function(module) {
            module.instance.destroy();
        });

        _moduleStack = [];
    };

    exports.getActiveModule = function(){
      return _activeModule;
    };

    return exports;
};

export default Modules;
